// Deployment-mode resolver — 'online' (web) or 'kiosk' (standalone cabinet).
// Priority: URL param (?mode=kiosk) → REACT_APP_DEPLOYMENT_MODE env → 'online'.
// Default is 'online' so existing web behavior is unchanged.

const VALID = ['online', 'kiosk'];

export function resolveDeploymentMode() {
  try {
    if (typeof window !== 'undefined' && window.location) {
      const p = new URLSearchParams(window.location.search).get('mode');
      if (VALID.includes(p)) return p;
    }
  } catch (_e) { /* ignore */ }

  try {
    const envMode = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_DEPLOYMENT_MODE) || '';
    if (VALID.includes(envMode)) return envMode;
  } catch (_e) { /* ignore */ }

  return 'online';
}
